import { Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DataSourceQuery } from '../../../datasource/data-source-query';
import { DocumentDataSourceService } from '../../../datasource/document-data-source.service';

export class E5coreUiSelectFromListBaseComponent implements OnInit {
	@Input() datasource: DocumentDataSourceService;
	@Input() query: DataSourceQuery ;
	@Input() autoSearch:boolean ;
	@Input() pagesizes: number[];
	@Input() error: string;

	@Output() listItemViewEvent = new EventEmitter();
	@Output() listItemSelectEvent = new EventEmitter();
	@Output() searchEvent = new EventEmitter();

	searchText : string;

	ngOnInit(): void {
	}

	/**
	 *  Pass the open work item event on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onOpen(data: any) {
		this.listItemViewEvent.emit({ event:event, element: data });
	}

	/**
	 *  Pass the open link on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onSelect(data: any) {
		this.listItemSelectEvent.emit({ event:event, element: data });
	}

	/**
	 *  Pass the open link on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onLink(link: string) {
		this.listItemViewEvent.emit({ event:event, element: link });
	}

	/**
	 * Execute a search with the required search expression values.
	 * @param expression the fields and values required to perform the search.
	 */
	public search() {
		if (this.searchText)
			this.searchEvent.emit(this.searchText);
	}

	/**
	 * Clear the search results.
	 */
	public reset() {
	}

	/**
	 * Refresh the search results at the current page.
	 */
	public refresh() {
	}
}
